import React from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {StripeBanner} from '../../../partials/widgets'
import {toAbsoluteUrl} from '../../../helpers'
import {ROUTES} from '../../../constants'
import {UseSessionBanner, isWithin} from '../../../hooks/UseSessionBanner'

const SESSION_KEY = 'banner_dismissed_baeguard'
// PRD §2.1.4 — effective September 1st (US Pacific), persistent thereafter.
const EFFECTIVE_FROM = '2026-09-01T00:00:00-07:00'

const BaeGuardStripeBanner: React.FC = () => {
  const intl = useIntl()
  const {dismissed, dismiss} = UseSessionBanner(SESSION_KEY)

  if (dismissed || !isWithin(EFFECTIVE_FROM)) return null

  return (
    <StripeBanner
      background='#1367AB'
      variant='baeguard'
      to={ROUTES.SETTINGS.INSURANCE}
      onClose={dismiss}
      cta={{
        label: intl.formatMessage({id: 'BUTTON_KEY_AUTO_BAEGUARD'}),
        background: '#18517F',
        color: '#FFFFFF',
      }}
      icon={
        <>
          <img
            src={toAbsoluteUrl('/media/gori/promotions/baeguard/baeguard-shield.svg')}
            alt=''
            height={36}
          />
          <img
            src={toAbsoluteUrl('/media/logos/baeguard-logo-white.svg')}
            alt='BaeGuard'
            height={15}
          />
        </>
      }
    >
      <span className='stripe-banner__divider' />
      <p className='stripe-banner__title'>{intl.formatMessage({id: 'BANNER_BAEGUARD_TITLE'})}</p>
      <p className='stripe-banner__subtext'>
        {intl.formatMessage({id: 'BAEGUARD_CAROUSEL_SUBTEXT'})}
      </p>
      <Link to={ROUTES.HELP_CENTER.BAE_GUARD} className='stripe-banner__link'>
        {intl.formatMessage({id: 'LEARN_MORE'})}
      </Link>
    </StripeBanner>
  )
}

export {BaeGuardStripeBanner}
